import './DownloadDetailedInfo.scss';

export const DownloadDetailedInfo = ({
  latestRelease,
}: {
  latestRelease: string;
}) => (
  <div className="download-detailed-info" data-testid="download-detailed-info">
    <div className="download-detailed-info__header">
      <h2 className="download-detailed-info__header-text">Details</h2>
    </div>
    <div className="download-detailed-info__row">
      <p className="download-detailed-info__row-title">Latest release</p>
      <p className="download-detailed-info__row-description">{latestRelease}</p>
    </div>
  </div>
);
